import { render, staticRenderFns } from "./boolean-checkbox.vue?vue&type=template&id=5ccd340a&"
import script from "./boolean-checkbox.vue?vue&type=script&lang=ts&"
export * from "./boolean-checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ccd340a')) {
      api.createRecord('5ccd340a', component.options)
    } else {
      api.reload('5ccd340a', component.options)
    }
    module.hot.accept("./boolean-checkbox.vue?vue&type=template&id=5ccd340a&", function () {
      api.rerender('5ccd340a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/boolean-checkbox.vue"
export default component.exports